module.exports = __webpack_public_path__ + "img/42.90a4e47b.jpg";